var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:none;stroke:#FEC053;stroke-miterlimit:10;}\r\n\t.st2{display:inline;fill:#FFFFFF;stroke:#FEC053;stroke-miterlimit:10;}\r\n\t.st3{display:inline;}\r\n\t.st4{fill:#FFFFFF;stroke:#FEC053;stroke-miterlimit:10;}\r\n\t.st5{fill:#FEC053;}\r\n\t.st6{fill:none;stroke:#FEC053;stroke-miterlimit:10;}\r\n\t.st7{display:inline;fill:none;stroke:#D9D8D6;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#D9D8D6;stroke-miterlimit:10;}\r\n\t.st9{fill:#D9D8D6;}\r\n\t.st10{display:inline;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st11{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st12{fill:#FFFFFF;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st14{display:inline;fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#FFFFFF;stroke-width:0.8563;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20.2,15.3 11.9,10.1 11.5,19.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.2,15.3 10.9,10.7 10.6,19.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 9.5,
    className: "st2",
    width: 0.3,
    height: 11.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 9.5,
    className: "st4",
    width: 0.3,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 9.5,
    className: "st4",
    width: 0.3,
    height: 11.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.8,14.7 19.1,19.3 19.4,10.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 9.4,
    className: "st1",
    width: 0.3,
    height: 11.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.4,16.4c-0.1,0.4-0.2,0.8-0.3,1.2c-0.7,1.4-1.8,2.2-3.3,2.5c-0.2,0-0.4,0-0.6,0c-2.9,0-5.8,0-8.7,0 c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.1,0.1,0.1c0.4,0.4,0.9,0.9,1.3,1.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0.1-0.5-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.6-0.6-1.2-1.2-1.9-1.9c-0.3-0.3-0.3-0.5,0-0.8c0.7-0.7,1.5-1.5,2.2-2.2 c0.1-0.1,0.2-0.2,0.4-0.2s0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.3,0,0.5c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.4-0.8,0.8-1.3,1.3l-0.1,0.1h0.1 c2.9,0,5.9,0,8.8,0c1.6,0,2.8-1,3.2-2.6c0.1-0.2,0.1-0.5,0.1-0.7c0-0.6,0-1.1,0-1.7c0-0.3,0.1-0.5,0.3-0.5c0.2-0.1,0.4,0,0.6,0.3 C22.4,14.7,22.4,15.6,22.4,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.4,10.5c0,0.1-0.1,0.2-0.2,0.3c-0.7,0.7-1.4,1.4-2.2,2.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0-0.4-0.1-0.5-0.3 s-0.1-0.4,0.1-0.6c0.4-0.4,0.9-0.9,1.3-1.3l0.1-0.1h-0.1c-2.9,0-5.8,0-8.7,0c-1.6,0-2.9,1-3.2,2.6c-0.1,0.2-0.1,0.5-0.1,0.7 c0,0.6,0,1.2,0,1.7c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5c0-0.6,0-1.3,0-1.9c0-1,0.4-1.9,1-2.6c0.7-0.8,1.7-1.3,2.8-1.4 c0.2,0,0.3,0,0.5,0c2.9,0,5.8,0,8.7,0c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.1-0.1-0.1c-0.4-0.4-0.9-0.9-1.3-1.3 c-0.3-0.3-0.3-0.7,0.1-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.7,0.7,1.4,1.4,2.2,2.2c0.1,0.1,0.1,0.2,0.2,0.3 C22.4,10.3,22.4,10.4,22.4,10.5z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 19.8,
    y1: 10.2,
    x2: 10.2,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.2,10.2c9.5,9.5,9.5,9.5,9.5,9.5"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "20.2,15.3 11.9,10.1 11.5,19.9  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "18.2,15.3 10.9,10.7 10.6,19.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 9.5,
    className: "st7",
    width: 0.3,
    height: 11.1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 9.5,
    className: "st8",
    width: 0.3,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 9.5,
    className: "st8",
    width: 0.3,
    height: 11.1
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "11.8,14.7 19.1,19.3 19.4,10.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 9.4,
    className: "st7",
    width: 0.3,
    height: 11.1
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.4,16.4c-0.1,0.4-0.2,0.8-0.3,1.2c-0.7,1.4-1.8,2.2-3.3,2.5c-0.2,0-0.4,0-0.6,0c-2.9,0-5.8,0-8.7,0 c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.1,0.1,0.1c0.4,0.4,0.9,0.9,1.3,1.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0.1-0.5-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.6-0.6-1.2-1.2-1.9-1.9c-0.3-0.3-0.3-0.5,0-0.8c0.7-0.7,1.5-1.5,2.2-2.2 c0.1-0.1,0.2-0.2,0.4-0.2s0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.3,0,0.5c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.4-0.8,0.8-1.3,1.3l-0.1,0.1h0.1 c2.9,0,5.9,0,8.8,0c1.6,0,2.8-1,3.2-2.6c0.1-0.2,0.1-0.5,0.1-0.7c0-0.6,0-1.1,0-1.7c0-0.3,0.1-0.5,0.3-0.5c0.2-0.1,0.4,0,0.6,0.3 C22.4,14.7,22.4,15.6,22.4,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.4,10.5c0,0.1-0.1,0.2-0.2,0.3c-0.7,0.7-1.4,1.4-2.2,2.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0-0.4-0.1-0.5-0.3 s-0.1-0.4,0.1-0.6c0.4-0.4,0.9-0.9,1.3-1.3l0.1-0.1h-0.1c-2.9,0-5.8,0-8.7,0c-1.6,0-2.9,1-3.2,2.6c-0.1,0.2-0.1,0.5-0.1,0.7 c0,0.6,0,1.2,0,1.7c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5c0-0.6,0-1.3,0-1.9c0-1,0.4-1.9,1-2.6c0.7-0.8,1.7-1.3,2.8-1.4 c0.2,0,0.3,0,0.5,0c2.9,0,5.8,0,8.7,0c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.1-0.1-0.1c-0.4-0.4-0.9-0.9-1.3-1.3 c-0.3-0.3-0.3-0.7,0.1-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.7,0.7,1.4,1.4,2.2,2.2c0.1,0.1,0.1,0.2,0.2,0.3 C22.4,10.3,22.4,10.4,22.4,10.5z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 19.8,
    y1: 10.2,
    x2: 10.2,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.2,10.2c9.5,9.5,9.5,9.5,9.5,9.5"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "20.2,15.3 11.9,10.1 11.5,19.9  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "18.2,15.3 10.9,10.7 10.6,19.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 9.5,
    className: "st10",
    width: 0.3,
    height: 11.1
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 9.5,
    className: "st11",
    width: 0.3,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 9.5,
    className: "st11",
    width: 0.3,
    height: 11.1
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "11.8,14.7 19.1,19.3 19.4,10.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 9.4,
    className: "st10",
    width: 0.3,
    height: 11.1
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M22.4,16.4c-0.1,0.4-0.2,0.8-0.3,1.2c-0.7,1.4-1.8,2.2-3.3,2.5c-0.2,0-0.4,0-0.6,0c-2.9,0-5.8,0-8.7,0 c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.1,0.1,0.1c0.4,0.4,0.9,0.9,1.3,1.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0.1-0.5-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.6-0.6-1.2-1.2-1.9-1.9c-0.3-0.3-0.3-0.5,0-0.8c0.7-0.7,1.5-1.5,2.2-2.2 c0.1-0.1,0.2-0.2,0.4-0.2s0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.3,0,0.5c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.4-0.8,0.8-1.3,1.3l-0.1,0.1h0.1 c2.9,0,5.9,0,8.8,0c1.6,0,2.8-1,3.2-2.6c0.1-0.2,0.1-0.5,0.1-0.7c0-0.6,0-1.1,0-1.7c0-0.3,0.1-0.5,0.3-0.5c0.2-0.1,0.4,0,0.6,0.3 C22.4,14.7,22.4,15.6,22.4,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M22.4,10.5c0,0.1-0.1,0.2-0.2,0.3c-0.7,0.7-1.4,1.4-2.2,2.2c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.2,0-0.4-0.1-0.5-0.3s-0.1-0.4,0.1-0.6c0.4-0.4,0.9-0.9,1.3-1.3l0.1-0.1h-0.1c-2.9,0-5.8,0-8.7,0c-1.6,0-2.9,1-3.2,2.6 c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.6,0,1.2,0,1.7c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5c0-0.6,0-1.3,0-1.9c0-1,0.4-1.9,1-2.6 c0.7-0.8,1.7-1.3,2.8-1.4c0.2,0,0.3,0,0.5,0c2.9,0,5.8,0,8.7,0c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.1-0.1-0.1c-0.4-0.4-0.9-0.9-1.3-1.3 c-0.3-0.3-0.3-0.7,0.1-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.7,0.7,1.4,1.4,2.2,2.2c0.1,0.1,0.1,0.2,0.2,0.3 C22.4,10.3,22.4,10.4,22.4,10.5z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 19.8,
    y1: 10.2,
    x2: 10.2,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M10.2,10.2c9.5,9.5,9.5,9.5,9.5,9.5"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 15,
    cy: 15,
    rx: 13,
    ry: 12.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "20,13.8 15,18.7 10,13.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 15,
    y1: 7.9,
    x2: 15,
    y2: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 10.4,
    y1: 20.3,
    x2: 19.8,
    y2: 20.3
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 15,
    cy: 15,
    rx: 13.2,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M16.4,9.4c0,0.6-0.4,1.1-1.1,1.1c-0.6,0-1-0.5-1-1.1c0-0.6,0.5-1.1,1.1-1.1C15.9,8.3,16.4,8.8,16.4,9.4z  M14.4,21.7v-9.6h1.7v9.6H14.4z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 15,
    cy: 15,
    rx: 13.2,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "19.7,15.6 19.7,19.6 10.3,19.6 10.3,10.4 14.4,10.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "15.3,10.4 19.7,10.4 19.7,14.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 19.7,
    y1: 10.4,
    x2: 15,
    y2: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.311941656ef6a3d33478273e91286ac9.svg";
export { ForwardRef as ReactComponent };